import { useInjectSaga } from "../utils/redux-injectors";
import SearchSaga from "./pages/Search/saga";
import DataCoverageSaga from "./pages/DataCoverage/pages/saga";
import OtherKindCodesSaga from "./pages/DocumentView/saga";

export function combineSagas() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useInjectSaga({ key: "search", saga: SearchSaga });
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useInjectSaga({ key: "dataCoverage", saga: DataCoverageSaga });
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useInjectSaga({ key: "otherKindCodes", saga: OtherKindCodesSaga });
}